class HomeNewArrivals {
  constructor(container) {
    this.container = container;
    this.grid = container.querySelector('[data-product-grid]');
    this.url = container.dataset.bestsellerUrl;

    if (!this.grid || !this.url) return;
    this.loadBestSellers();
  }

  async loadBestSellers() {
    try {
      const response = await fetch(this.url, { credentials: 'same-origin' });
      if (!response.ok) return;

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fetchedGrid = doc.querySelector('[data-product-grid]');
      if (!fetchedGrid) return;

      this.grid.innerHTML = fetchedGrid.innerHTML;
    } catch (error) {
      console.warn('home-new-arrivals: failed to load best sellers', error);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.home-new-arrivals .collection[data-bestseller-url]').forEach((container) => {
    new HomeNewArrivals(container);
  });
});
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-bestseller-url]').forEach(function (container) {
    var url = container.dataset.bestsellerUrl;
    var grid = container.querySelector('[data-product-grid]');

    if (!url || !grid) return;

    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('home-new-arrivals: fetch failed ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-product-grid]');
        if (newGrid && newGrid.children.length > 0) {
          grid.innerHTML = newGrid.innerHTML;
        }
      })
      .catch(function (e) { console.error(e); });
  });
});
